import { useId } from 'react';
import { Link } from 'react-router';
import { provelengde } from '../lib/plans';
import { nårDetSlutter, provesluttdato } from '../lib/proveperiode';

/**
 * Tilbudet på sidene der man velger pakke: Plus gratis de første ukene.
 *
 * Står over pakkekortene, ikke inne i ett av dem. Det gjelder uansett hvilket
 * kort man trykker på – også den som begynner gratis, og den som kjøper
 * Standard med det samme – og et merke på Plus-kortet ville sagt at man må
 * velge Plus for å få det.
 *
 * Tilbudet er det man skal se, så det er det største i boksen, og boksen er
 * mørk mot den lyse sida. Forklaringen av hvordan perioden virker, står ikke
 * her lenger – den konkurrerte med tilbudet om oppmerksomheten. Den står ved
 * pakkekortene på prislista (`PlusProveVilkaar`), og i spørsmålene under.
 *
 * Bare for den som ikke har konto. Perioden regnes fra registreringen, og en
 * som allerede er kunde, har enten hatt den eller har den nå. Å love dem noe
 * de ikke kan få, er verre enn å tie.
 */
export function PlusProveTilbud() {
  const tittelId = useId();
  return (
    <aside className="provetilbud" aria-labelledby={tittelId}>
      {/* Én overskrift over to linjer, ikke to overskrifter. Mellomrommet
          etter linjeskiftet er for skjermlesere og kopiering: uten det blir
          det «gratismed». På skjermen faller det bort i starten av linja. */}
      <h2 className="provetilbud-tittel" id={tittelId}>
        {provelengde()} gratis
        <br /> med Plus
      </h2>
      <p className="provetilbud-tekst">
        Få en enklere start på bryllupsplanleggingen – med alle verktøyene, inkludert
        bordplassering.
      </p>
      <Link className="btn btn-lg provetilbud-knapp" to="/registrer">
        {/* Hardt mellomrom: brekker knappen likevel, skal «Plus» ikke stå
            alene på andre linje. */}
        Start gratis med{'\u00a0'}Plus <span aria-hidden="true">→</span>
      </Link>
      <p className="provetilbud-trygghet">Ingen betalingskort. Ingen automatisk betaling.</p>
    </aside>
  );
}

/**
 * Hvordan gratisperioden virker, i ett avsnitt ved pakkekortene.
 *
 * Sto tidligere i selve tilbudsboksen. Der tok den oppmerksomheten fra
 * tilbudet, men den svarer på det neste man lurer på når man ser kortene:
 * gjelder det også om vi velger Gratis, eller kjøper Standard? Derfor står den
 * rett under dem på prislista, og bare der tilbudet står – for den som ikke
 * har konto.
 */
export function PlusProveVilkaar() {
  return (
    <p className="provevilkaar">
      <strong>Prøv alle verktøyene:</strong> Dere får Plus gratis i {provelengde()} fra dere
      oppretter konto, uansett hvilken pakke dere velger. Ingen betalingskort eller automatisk
      betaling.
    </p>
  );
}

/**
 * Boksen nederst i sidemenyen mens gratisperioden løper.
 *
 * Tar plassen til oppgraderingsboksen som står der ellers. Den forsvant med
 * Plus – men et par som prøver Plus, er nettopp de som trenger å vite at det
 * har en slutt, og når.
 */
export function Provestatus({ plusProveTil }: { plusProveTil: string }) {
  return (
    <div className="upsell">
      <h4>Plus gratis til {provesluttdato(plusProveTil)}</h4>
      <p>
        Dere har alle verktøyene i gratisperioden. Den slutter {nårDetSlutter(plusProveTil)} –
        oppgrader for å beholde dem etterpå.
      </p>
      <Link className="btn btn-primary btn-sm btn-block" to="/app/abonnement">
        Se pakkene
      </Link>
    </div>
  );
}
